import React from 'react';
import { cn } from '../lib/cn';

type RowTheme = 'light' | 'dark' | 'orange';

interface IndexRowProps {
  category: string;
  index: string;
  name: string;
  theme?: RowTheme;
  href?: string;
  target?: string;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const themeClasses: Record<RowTheme, string> = {
  light:  'surface-light text-black',
  dark:   'surface-dark text-avaris-light',
  orange: 'surface-orange text-black',
};

export default function IndexRow({
  category,
  index,
  name,
  theme = 'light',
  href,
  target,
  onClick,
  className,
  style,
}: IndexRowProps) {
  const classes = cn('flex h-12 w-full items-center gap-2 px-4 font-trispace', themeClasses[theme], className);

  const content = (
    <>
      <span className="type-section-label w-16 shrink-0 overflow-hidden text-ellipsis whitespace-nowrap">
        {category}
      </span>
      <span className="type-section-label shrink-0">{index}</span>
      <span className="type-menu-item">{name}</span>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        className={classes}
        style={style}
        onClick={onClick}
      >
        {content}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" className={classes} style={style} onClick={onClick}>
        {content}
      </button>
    );
  }

  return (
    <div className={classes} style={style}>
      {content}
    </div>
  );
}
